import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import React, { useState, useEffect, useRef } from 'react';

import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';

import Page from '../../components/Page';
import RegulationsImage from '../../assets/img/regulations_bg.png';
import RegulationsImage2 from '../../assets/img/RegulationsBackground-Home2.jpg';
import RegulationsImage3 from '../../assets/img/regulations-3.png';
import { createGlobalStyle } from 'styled-components';
import useTombFinance from '../../hooks/useTombFinance';
import CardBG from '../../assets/img/CardBackground.png';
import CardBGHome2 from '../../assets/img/CardBackground-Home2.png';
import CardBGHome3 from '../../assets/img/CardBackground-3.png';
import { useTwitterAnalysis } from '../../hooks/useTwitterAnalysis';
import { getDisplayBalance } from '../../utils/formatBalance';
import useBurnedBalances from '../../hooks/useBurnedBalances';
import TokenSymbol from './../../components/TokenSymbol/TokenSymbol';
import ShimmerLoader from '../../components/ShimmerLoader';
import * as echarts from 'echarts';
import axios from 'axios';
import useBondStats from '../../hooks/useBondStats';

const StyledTableCell = withStyles((theme) => ({
  head: {
    fontSize: 18,
    background: `${localStorage.getItem('theme') === "theme-1" ? (`url('${CardBG}')`) : localStorage.getItem('theme') === "theme-2" ? (`url('${CardBGHome2}')`) : (`url('${CardBGHome3}')`)}`,
    border: "solid 3px #38332Eaa",
    boxShadow: "inset 0 0 10px #000000",
    // backgroundColor: 'rgba(255, 255, 255, 0.9)',
    textShadow: '-2px 0 black, 0 2px black, 2px 0 black, 0 -2px black',
    color: '#dc9d3f',
    fontWeight: 'bolder',
  },
  body: {
    fontSize: 14,
    color: '#dc9d3f',
  },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
  gridItem: {
    height: '100%',
    [theme.breakpoints.up('md')]: {
      height: '90px',
    },
  },
}));

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: 'rgb(0,0,0)',
    },
  },
}))(TableRow);

const formatNumber = (value) => {
  if (value >= 1000000) {
    // For values 1M and above, show full number with commas, no decimals
    return Math.round(value).toLocaleString('en-US');
  } else if (value >= 1000) {
    // For values 1k and above, show with commas, no decimals
    return Math.round(value).toLocaleString('en-US');
  } else {
    // For values less than 1k, show without decimals
    return Math.round(value);
  }
};

// Add these constants at the top level of the file
const EMISSION_RATES = {
  before29: {
    hogOs: 0.000558366,
    ghogOs: 0.001302854
  },
  after29: {
    hogOs: 0.000651427,
    ghogOs: 0.001209793
  },
  after57: {
    hogOs: 0.000558366,
    ghogOs: 0.001302854
  }
};

// First, let's add these color constants at the top of the file (after the imports)
const PRICE_COLORS = {
  EXPANSION: 'rgba(34, 255, 66, 0.1)',  // Green with opacity
  ZEN: 'rgba(255, 187, 0, 0.1)',        // Yellow with opacity
  CONTRACTION: 'rgba(255, 66, 66, 0.1)'  // Red with opacity
};

// Add this function outside the component to fetch epoch stats
const fetchEpochStats = async () => {
  try {
    // GraphQL query to fetch stability data
    const query = `{
      epochStats_collection {
        totalEpochs
        printEpochs
        zenEpochs
        contractionEpochs
      }
    }`;

    const url = 'https://api.studio.thegraph.com/query/108183/handofgod/version/latest';
    const headers = { 
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ed17781988cec49a43c4caa08932adfe'
    };

    const response = await axios({
      url,
      method: 'POST',
      headers,
      data: {
        query
      }
    });
    
    console.log("GraphQL response:", response.data);
    
    if (response.data && response.data.data && response.data.data.epochStats_collection) {
      // Convert string values to numbers
      const epochStats = response.data.data.epochStats_collection[0];
      return [{
        printEpochs: parseInt(epochStats.printEpochs, 10),
        totalEpochs: parseInt(epochStats.totalEpochs, 10),
        zenEpochs: parseInt(epochStats.zenEpochs, 10),
        contractionEpochs: parseInt(epochStats.contractionEpochs, 10)
      }];
    } else {
      console.warn("No data found in GraphQL response:", response.data);
      // Return fallback values if no data is returned
      return [{
        printEpochs: 22,
        totalEpochs: 101,
        zenEpochs: 17,
        contractionEpochs: 14
      }];
    }
  } catch (error) {
    console.error('Error fetching epoch stats:', error);
    // Return fallback values in case of error
    return [{
      printEpochs: 22,
      totalEpochs: 101,
      zenEpochs: 17,
      contractionEpochs: 14
    }];
  }
};

const fetchEpochSummaries = async () => {
  try {
    const query = `{
      epochSummaries {
        id
        hogPrice
        burnAmount
        hogTotalSupply
        discountRate
        expansionRate
        daoFundAmount
        devFundAmount
        teamFundAmount
        totalFundAmount
        totalEmissionRate
        pool0EmissionRate
        pool1EmissionRate
      }
    }`;

    const url = 'https://api.studio.thegraph.com/query/108183/handofogod/v0.0.2';
    const headers = { 
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ed17781988cec49a43c4caa08932adfe'
    };
    
    const response = await axios({
      url,
      method: 'POST',
      headers,
      data: { query }
    });

    if (response.data && response.data.data && response.data.data.epochSummaries) {
      const summaries = response.data.data.epochSummaries;
      console.log("Fetched epoch summaries:", summaries);
      return summaries;
    } else {
      console.warn("No data found in GraphQL response:", response.data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching epoch summaries:', error);
    return [];
  }
};

const TWAPChart = ({ data }) => {
  const theme = useTheme();
  const [stabilityData, setStabilityData] = useState([
    { name: 'Print', value: 22, color: '#22ff42' },
    { name: 'Zen', value: 17, color: '#ffbb00' },
    { name: 'Contraction', value: 14, color: '#ff4242' }
  ]);
  const [totalEpochs, setTotalEpochs] = useState(101);
  const lineChartRef = useRef(null);
  const pieChartRef = useRef(null);
  const [showExpansionRate, setShowExpansionRate] = useState(false);
  const [showEmissionChanges, setShowEmissionChanges] = useState(false);
  
  // Fetch epoch stats when component mounts
  useEffect(() => {
    const getEpochStats = async () => {
      const stats = await fetchEpochStats();
      if (stats && stats.length > 0) {
        const epochStats = stats[0];
        setStabilityData([
          { name: 'Print', value: epochStats.printEpochs, color: '#22ff42' },
          { name: 'Zen', value: epochStats.zenEpochs, color: '#ffbb00' },
          { name: 'Contraction', value: epochStats.contractionEpochs, color: '#ff4242' }
        ]);
        setTotalEpochs(epochStats.totalEpochs);
      }
    };
    
    getEpochStats();
  }, []);
  
  // Initialize ECharts pie chart
  useEffect(() => {
    // Initialize the pie chart
    if (pieChartRef.current) {
      const pieChart = echarts.init(pieChartRef.current);
      
      const pieOption = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        series: [
          {
            name: 'Stability',
            type: 'pie',
            radius: ['65px', '90px'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 4,
              borderWidth: 0
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false
              }
            },
            data: stabilityData.map(item => ({
              value: item.value,
              name: item.name,
              itemStyle: {
                color: item.color
              }
            }))
          }
        ],
        graphic: {
          elements: [
            {
              type: 'text',
              left: 'center',
              top: '42%',
              style: {
                text: totalEpochs.toString(),
                fontSize: 32,
                fontWeight: 'bold',
                fill: '#ffffff',
                width: 30,
                height: 30
              }
            },
            {
              type: 'text',
              left: 'center',
              top: '58%',
              style: {
                text: 'epoch',
                fontSize: 18,
                fill: '#ffffff'
              }
            }
          ]
        }
      };
      
      pieChart.setOption(pieOption);
      
      // Resize chart when window size changes
      const resizeObserver = new ResizeObserver(() => {
        pieChart.resize();
      });
      resizeObserver.observe(pieChartRef.current);
      
      return () => {
        resizeObserver.disconnect();
        pieChart.dispose();
      };
    }
  }, [stabilityData, totalEpochs]);
  
  // Initialize ECharts line chart
  useEffect(() => {
    if (lineChartRef.current && data && data.length > 0) {
      const lineChart = echarts.init(lineChartRef.current);
      
      // Sort data by epoch in ascending order
      const sortedData = [...data].sort((a, b) => parseInt(a.epoch) - parseInt(b.epoch));
      
      const lineOption = {
        backgroundColor: 'transparent',
        grid: {
          left: 60,
          right: 80, // Increased to make room for the button
          top: 25,
          bottom: 70,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            let result = `Epoch: ${params[0].name}<br/>`;
            params.forEach(param => {
              if (param.seriesName === 'HOG Price') {
                result += `${param.seriesName}: ${param.value}<br/>`;
              } else if (param.seriesName === 'Expansion Rate' && showExpansionRate) {
                result += `${param.seriesName}: ${param.value}%<br/>`;
              } else if (param.seriesName === 'Total Funded') {
                result += `${param.seriesName}: ${param.value} HOG<br/>`;
              } else if (param.seriesName === 'Burn Amount') {
                result += `${param.seriesName}: ${param.value} HOG`;
              }
            });
            return result;
          }
        },
        legend: {
          data: ['HOG Price', 'Expansion Rate', 'Total Funded', 'Burn Amount', 'Emission Changes'],
          right: 10,
          top: 0,
          textStyle: {
            color: '#ffffff'
          },
          selected: {
            'HOG Price': true,
            'Expansion Rate': showExpansionRate,
            'Total Funded': true,
            'Burn Amount': true,
            'Emission Changes': showEmissionChanges
          }
        },
        xAxis: {
          type: 'category',
          name: 'Epoch',
          nameLocation: 'middle',
          nameGap: 35,
          data: sortedData.map(item => item.epoch),
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: '#ffffff'
            }
          },
          axisTick: {
            alignWithLabel: true,
            lineStyle: {
              color: '#ffffff'
            }
          },
          axisLabel: {
            color: '#ffffff',
            interval: 'auto',
            rotate: 0
          }
        },
        yAxis: [
          {
            type: 'value',
            name: 'HOG Price',
            nameLocation: 'middle',
            nameGap: 50,
            nameTextStyle: {
              color: '#ffffff'
            },
            min: 'dataMin',
            max: 'dataMax',
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            },
            axisLabel: {
              formatter: function(value) {
                return value.toFixed(4);
              },
              color: '#ffffff'
            },
            splitLine: {
              lineStyle: {
                color: '#38332Eaa',
                type: 'dashed'
              }
            }
          },
          {
            type: 'value',
            name: 'Expansion Rate (%)',
            nameLocation: 'middle',
            nameGap: 50,
            nameTextStyle: {
              color: '#ffffff'
            },
            min: 0,
            max: function(value) {
              return Math.ceil(value.max);
            },
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            },
            axisLabel: {
              formatter: '{value}%',
              color: '#ffffff'
            },
            splitLine: {
              show: false
            }
          },
          {
            type: 'value',
            name: 'HOG Funded',
            position: 'right',
            offset: 40,
            nameLocation: 'middle',
            nameGap: 50,
            nameTextStyle: {
              color: '#ffffff'
            },
            min: 0,
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            },
            axisLabel: {
              formatter: '{value}',
              color: '#ffffff'
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: 'HOG Price',
            type: 'line',
            data: sortedData.map((item, index) => {
              const currentPrice = parseFloat(item.twap);
              const prevPrice = index > 0 ? parseFloat(sortedData[index - 1].twap) : currentPrice;
              const nextPrice = index < sortedData.length - 1 ? parseFloat(sortedData[index + 1].twap) : currentPrice;
              
              // Check if it's a local maximum or minimum
              const isLocalMax = currentPrice > prevPrice && currentPrice > nextPrice;
              const isLocalMin = currentPrice < prevPrice && currentPrice < nextPrice;
              
              // Check for zone transitions
              const prevInDifferentZone = index > 0 && (
                (currentPrice >= 1.00 && currentPrice <= 1.01 && (prevPrice > 1.01 || prevPrice < 1.00)) ||
                (currentPrice > 1.01 && prevPrice <= 1.01) ||
                (currentPrice < 1.00 && prevPrice >= 1.00)
              );
              
              let itemStyle = { color: 'transparent' };
              
              if (currentPrice > 1.01 && (isLocalMax || (prevInDifferentZone && prevPrice < currentPrice))) {
                itemStyle.color = '#22ff42'; // Green for peaks above 1.01
              } else if (currentPrice >= 1.00 && currentPrice <= 1.01 && 
                        (isLocalMax || isLocalMin || (prevInDifferentZone && prevPrice > currentPrice))) {
                itemStyle.color = '#ffbb00'; // Yellow for peaks, valleys, and entries into zen zone
              } else if (currentPrice < 1.00 && (isLocalMax || isLocalMin || prevInDifferentZone)) {
                itemStyle.color = '#ff4242'; // Red for peaks and valleys below 1.00
              }
              
              return {
                name: item.epoch,
                value: currentPrice,
                itemStyle: itemStyle
              };
            }),
            symbol: 'circle',
            symbolSize: 8,
            showSymbol: true,
            lineStyle: {
              color: '#FF8A3D',
              width: 2
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(255, 138, 61, 0.5)' },
                { offset: 1, color: 'rgba(255, 138, 61, 0.05)' }
              ])
            }
          },
          {
            name: 'Expansion Rate',
            type: 'line',
            yAxisIndex: 1,
            data: sortedData.map(item => ({
              name: item.epoch,
              value: item.isExpansion ? item.expansionRate : 0
            })),
            symbol: 'none',
            lineStyle: {
              color: '#808080',
              width: 2
            }
          },
          {
            name: 'Total Funded',
            type: 'bar',
            yAxisIndex: 2,
            data: sortedData.map(item => ({
              name: item.epoch,
              value: item.totalFundAmount || 0
            })),
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#22a69a' },
                { offset: 1, color: '#207b73' }
              ])
            },
            barWidth: '40%',
            barGap: '0%',
            barCategoryGap: '20%',
            z: 0
          },
          {
            name: 'Burn Amount',
            type: 'bar',
            yAxisIndex: 2,
            data: sortedData.map(item => ({
              name: item.epoch,
              value: item.burnAmount || 0
            })),
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#ff4242' },
                { offset: 1, color: '#992828' }
              ])
            },
            barWidth: '40%',
            barGap: '0%',
            barCategoryGap: '20%',
            z: 1
          },
          // Green reference line at 1.0100
          {
            name: 'Green Line (1.0100)',
            type: 'line',
            symbolSize: 0,
            symbol: 'none',
            markPoint: {
              symbol: 'none',
              data: [
                {
                  name: '1.0100',
                  coord: [sortedData[0].epoch, 1.0100],
                  label: {
                    show: true,
                    position: 'insideLeft',
                    formatter: '1.0100',
                    color: '#22ff42',
                    fontSize: 14,
                    fontWeight: 'bold',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    padding: [2, 4]
                  }
                }
              ]
            },
            lineStyle: {
              color: '#22ff42',
              width: 2,
              type: 'solid'
            },
            data: sortedData.map(item => ({
              name: item.epoch,
              value: 1.0100
            }))
          },
          // Yellow reference line at 1.0000
          {
            name: 'Yellow Line (1.0000)',
            type: 'line',
            symbolSize: 0,
            symbol: 'none',
            markPoint: {
              symbol: 'none',
              data: [
                {
                  name: '1.0000',
                  coord: [sortedData[0].epoch, 1.0000],
                  label: {
                    show: true,
                    position: 'insideLeft',
                    formatter: '1.0000',
                    color: '#FFFF00',
                    fontSize: 14,
                    fontWeight: 'bold',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    padding: [2, 4]
                  }
                }
              ]
            },
            lineStyle: {
              color: '#FFFF00',
              width: 2,
              type: 'solid'
            },
            data: sortedData.map(item => ({
              name: item.epoch,
              value: 1.0000
            }))
          },
          {
            name: 'Emission Changes',
            type: 'line',
            showSymbol: false,
            data: [],
            markLine: {
              silent: true,
              symbol: ['none', 'none'],
              label: {
                show: showEmissionChanges,
                formatter: function(params) {
                  const change = getEmissionChanges(sortedData).find(c => c.epoch === params.value);
                  if (!change) return '';
                  return [
                    'Emission Change',
                    `HOG/OS: ${change.pool0}`,
                    `GHOG/OS: ${change.pool1}`
                  ].join('\n');
                },
                position: 'insideStartTop',
                color: '#22ff42',
                fontSize: 12,
                fontWeight: 'bold',
                backgroundColor: 'rgba(0,0,0,0.7)',
                padding: [4, 8],
                borderRadius: 4,
                distance: 10
              },
              lineStyle: {
                color: '#22ff42',
                type: 'dashed',
                width: 2
              },
              data: getEmissionChanges(sortedData).map(change => ({
                xAxis: change.epoch,
                label: {
                  formatter: function() {
                    return [
                      'Emission Change',
                      `HOG/OS: ${change.pool0}`,
                      `GHOG/OS: ${change.pool1}`
                    ].join('\n');
                  }
                }
              }))
            }
          }
        ],
        dataZoom: [
          {
            type: 'inside',
            xAxisIndex: [0],
            start: 0,
            end: 100
          },
          {
            type: 'slider',
            height: 30,
            bottom: 10,
            borderColor: '#8884d8',
            backgroundColor: 'rgba(47, 69, 84, 0.3)',
            dataBackground: {
              lineStyle: {
                color: '#8884d8',
                width: 1
              },
              areaStyle: {
                color: 'rgba(136, 132, 216, 0.3)'
              }
            },
            fillerColor: 'rgba(136, 132, 216, 0.3)',
            handleStyle: {
              color: '#8884d8'
            },
            start: 0,
            end: 100
          }
        ]
      };
      
      lineChart.setOption(lineOption);
      
      // Add click event handler for the legend
      lineChart.on('legendselectchanged', function(params) {
        if (params.name === 'Expansion Rate') {
          setShowExpansionRate(params.selected['Expansion Rate']);
        } else if (params.name === 'Emission Changes') {
          setShowEmissionChanges(params.selected['Emission Changes']);
        }
      });
      
      // Resize chart when window size changes
      const resizeObserver = new ResizeObserver(() => {
        lineChart.resize();
      });
      resizeObserver.observe(lineChartRef.current);
      
      return () => {
        resizeObserver.disconnect();
        lineChart.dispose();
      };
    }
  }, [data, showExpansionRate, showEmissionChanges]);
  
  // Add a function to detect emission rate changes
  const getEmissionChanges = (sortedData) => {
    const changes = [];
    for (let i = 1; i < sortedData.length; i++) {
      const current = sortedData[i];
      const previous = sortedData[i - 1];
      
      if (
        current.pool0EmissionRate !== previous.pool0EmissionRate ||
        current.pool1EmissionRate !== previous.pool1EmissionRate
      ) {
        changes.push({
          epoch: current.epoch,
          pool0: current.pool0EmissionRate,
          pool1: current.pool1EmissionRate
        });
      }
    }
    return changes;
  };

  return (
    <div className="w-full max-w-7xl mx-auto px-4 md:px-8 mb-8">
      <div className="flex flex-col md:flex-row w-full" style={{ gap: '1rem' }}>
        {/* Stability Legend Box - exactly 20% width */}
        <div className="w-full md:w-[25%] flex-shrink-0 bg-card rounded-lg p-4 border border-[#38332Eaa] flex flex-col" style={{ maxWidth: '25%' }}>
          <h3 className="text-2xl mb-6 text-white font-bold" style={{ fontFamily: 'Urbanist' }}>Stability:</h3>
          <div className="flex flex-col space-y-6">
            <div className="flex items-center">
              <div className="w-3 h-3 rounded-full bg-[#22ff42] mr-4" style={{ backgroundColor: '#22ff42', minWidth: '12px' }}></div>
              <span className="text-white text-lg">1x Print - {stabilityData[0].value} Epochs</span>
            </div>
            <div className="flex items-center"> 
              <div className="w-3 h-3 rounded-full bg-[#ffbb00] mr-4" style={{ backgroundColor: '#ffbb00', minWidth: '12px' }}></div>
              <span className="text-white text-lg">1x Zen - {stabilityData[1].value} Epochs</span>
            </div>
            <div className="flex items-center">
              <div className="w-3 h-3 rounded-full bg-[#ff4242] mr-4" style={{ backgroundColor: '#ff4242', minWidth: '12px' }}></div>
              <span className="text-white text-lg">1x Contraction - {stabilityData[2].value} Epochs</span>
            </div>
          </div>
          
          {/* Pie Chart */}
          <div className="flex-grow flex items-center justify-center" style={{ minHeight: '300px' }}>
            <div ref={pieChartRef} style={{ width: '100%', height: '300px' }}></div>
          </div>
        </div>

        {/* TWAP Chart - exactly 75% width */}
        <div className="w-full md:w-[75%] flex-grow bg-card rounded-lg p-4 border border-[#38332Eaa]" style={{ width: '75%' }}>
          <h3 className="text-xl mb-4 text-[#dc9d3f] font-semibold">TWAP Chart</h3>
          <div className="w-full h-[300px]">
            <div ref={lineChartRef} style={{ width: '100%', height: '420px' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Regulations = () => {
  const classes = useStyles();
  const tombFinance = useTombFinance();
  const [rows, setRows] = useState(null);
  const [currentEpoch, setCurrentEpoch] = useState(null);
  const [tweetUrls, setTweetUrls] = useState({});
  const [expansionRates, setExpansionRates] = useState({});
  const { tweetUrl, expansionRate, loading } = useTwitterAnalysis(currentEpoch);
  const [epochData, setEpochData] = useState({});
  const { burnedBalances, tokenPrices, burnedValueUSD } = useBurnedBalances();
  const [totalHogBurned, setTotalHogBurned] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(7);
  const [chartData, setChartData] = useState([]);
  const bondStat = useBondStats();

  useEffect(() => {
    const getEpochSummaries = async () => {
      const summaries = await fetchEpochSummaries();
      
      // Sort summaries by epoch in descending order
      const sortedSummaries = [...summaries].sort((a, b) => parseInt(b.id) - parseInt(a.id));
      
      // Process the data
      const processedData = sortedSummaries.map(summary => {
        const twap = parseFloat(summary.hogPrice) / 1e18;
        const isExpansion = twap > 1.01;
        
        return {
          epoch: summary.id,
          twap: twap.toFixed(4),
          expansionRate: isExpansion ? (summary.expansionRate ? parseFloat(summary.expansionRate) / 1000 : 0) : 0,
          daoFundAmount: summary.daoFundAmount ? parseFloat(summary.daoFundAmount) / 1e18 : null,
          devFundAmount: summary.devFundAmount ? parseFloat(summary.devFundAmount) / 1e18 : null,
          teamFundAmount: summary.teamFundAmount ? parseFloat(summary.teamFundAmount) / 1e18 : null,
          totalFundAmount: summary.totalFundAmount ? parseFloat(summary.totalFundAmount) / 1e18 : null,
          burnAmount: summary.burnAmount ? parseFloat(summary.burnAmount) / 1e18 : 0,
          pool0EmissionRate: summary.pool0EmissionRate ? (parseFloat(summary.pool0EmissionRate) / 1e18).toFixed(8) : null,
          pool1EmissionRate: summary.pool1EmissionRate ? (parseFloat(summary.pool1EmissionRate) / 1e18).toFixed(8) : null,
          bondsBought: '0',
          bondsRedeemed: '0',
          isExpansion: isExpansion,
          isZen: twap >= 1.00 && twap <= 1.01,
          isContraction: twap < 1.00
        };
      });
      
      console.log("Processed data:", processedData);
      setChartData(processedData);
      
      // Set rows for table directly from subgraph data
      setRows(processedData);
      
      // Calculate total HOG burned from subgraph data
      const totalBurned = processedData.reduce((acc, row) => {
        const burnAmount = row.devFundAmount + row.teamFundAmount || 0;
        return acc + burnAmount;
      }, 0);
      
      setTotalHogBurned(totalBurned);
      
      // Only fetch GOD_AI data for visible rows initially
      const visibleRows = processedData.slice(0, rowsPerPage);
      const epochsToFetch = visibleRows.map(row => parseInt(row.epoch));
      await fetchEpochData(epochsToFetch);
    };

    getEpochSummaries();
  }, [rowsPerPage]);

  // Update the fetch epoch data function to accept an array of epoch numbers
  const fetchEpochData = async (epochs) => {
    const fetchPromises = epochs
      .filter(epoch => epoch !== 1) // Skip epoch 1
      .map(epoch => 
        fetch(`https://god-ai-api.vercel.app/epoch/${epoch}`)
          .then(response => response.json())
      );

    try {
      const results = await Promise.all(fetchPromises);
      const newEpochData = {};
      results.forEach(data => {
        newEpochData[data.epoch] = data;
      });
      
      // Set hardcoded data for epoch 1
      newEpochData[1] = {
        epoch: 1,
        expansion_rate: 0.15,
        tweet_url: 'https://x.com/GodSonic_AI/status/1897056995145904142'
      };
      
      setEpochData(prev => ({
        ...prev,
        ...newEpochData
      }));
    } catch (error) {
      console.error('Error fetching epoch data:', error);
    }
  };

  useEffect(() => {
    if (currentEpoch && (tweetUrl || expansionRate)) {
      setTweetUrls(prev => ({
        ...prev,
        [currentEpoch]: tweetUrl
      }));
      
      setExpansionRates(prev => ({
        ...prev,
        [currentEpoch]: expansionRate
      }));
      
      // Move to next epoch if there are more
      if (rows) {
        const currentIndex = rows.findIndex(row => row.epoch === currentEpoch);
        if (currentIndex < rows.length - 1) {
          setCurrentEpoch(rows[currentIndex + 1].epoch);
        }
      }
    }
  }, [currentEpoch, tweetUrl, expansionRate, rows]);

  const paginatedRows = rows ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : [];
  
  // Update handleChangePage to fetch data for new page
  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    if (rows) {
      const startIndex = newPage * rowsPerPage;
      const endIndex = startIndex + rowsPerPage;
      const newVisibleRows = rows.slice(startIndex, endIndex);
      
      // Check if we need to fetch GOD_AI data for these rows
      const epochsNeedingData = newVisibleRows
        .map(row => parseInt(row.epoch))
        .filter(epoch => epoch !== 1 && !epochData[epoch]);
      
      if (epochsNeedingData.length > 0) {
        await fetchEpochData(epochsNeedingData);
      }
    }
  };

  return (
    <Page>
        <div className="theme-dark bg-background text-foreground">
          <div className="container flex flex-row items-center gap-4 mx-auto justify-center py-4">
              <span className="whitespace-nowrap opacity-60">Burn Stats:</span>
            
            {/* Mobile Carousel */}
            <div className="md:hidden overflow-hidden relative">
              <div className="rfm-marquee-container"
                style={{
                  '--pause-on-hover': 'running',
                  '--pause-on-click': 'running',
                  '--width': '100%',
                  '--transform': 'none',
                  overflow: 'hidden',
                  position: 'relative'
                }}>
                <div className="rfm-overlay"
                  style={{
                    '--gradient-color': 'hsl(var(--background))',
                    '--gradient-width': '50px',
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 2
                  }} />
                <div className="rfm-marquee flex gap-4"
                  style={{
                    '--play': 'running',
                    '--direction': 'reverse',
                    '--duration': '5s',
                    '--delay': '0s',
                    '--iteration-count': 'infinite',
                    '--min-width': 'auto',
                    animation: 'scroll 5s linear infinite',
                    whiteSpace: 'nowrap'
                  }}>
                  {/* Duplicate cards for infinite scroll */}
                  {[...Array(2)].map((_, setIndex) => (
                    <div key={setIndex} className="flex gap-4" style={{ animation: 'none' }}>
                      {/* HOG/OS LP Card */}
                      <div className="min-w-[200px] p-4 bg-card rounded-lg shadow-lg flex flex-row items-center flex-shrink-0">
                        <div className="flex items-center">
                          <TokenSymbol symbol="HOG" size={30} />
                          <div className="ml-[-8px]">
                            <TokenSymbol symbol="OS" size={30} />
                          </div>
                        </div>
                        {burnedValueUSD?.hogOsLp ? (
                          <span className="ml-2">${formatNumber(burnedValueUSD.hogOsLp)}</span>
                        ) : (
                          <div className="ml-2">
                            <ShimmerLoader width="w-20" height="h-5" />
                          </div>
                        )}
                      </div>

                      {/* GHOG/OS LP Card */}
                      <div className="min-w-[200px] p-4 bg-card rounded-lg shadow-lg flex flex-row items-center flex-shrink-0">
                        <div className="flex items-center">
                          <TokenSymbol symbol="GHOG" size={30} />
                          <div className="ml-[-8px]">
                            <TokenSymbol symbol="OS" size={30} />
                          </div>
                        </div>
                        {burnedValueUSD?.ghogOsLp ? (
                          <span className="ml-2">${formatNumber(burnedValueUSD.ghogOsLp)}</span>
                        ) : (
                          <div className="ml-2">
                            <ShimmerLoader width="w-20" height="h-5" />
                          </div>
                        )}
                      </div>

                      {/* HOG Card */}
                      <div className="min-w-[200px] p-4 bg-card rounded-lg shadow-lg flex flex-row items-center flex-shrink-0">
                        <TokenSymbol symbol="HOG" size={30} />
                        <div className="ml-2">
                          {totalHogBurned && tokenPrices?.hog ? (
                            <span>${formatNumber(totalHogBurned * tokenPrices.hog)}</span>
                          ) : (
                            <ShimmerLoader width="w-20" height="h-5" />
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Desktop Layout */}
            <div className="hidden md:flex flex-row items-center gap-4">
              {/* HOG/OS LP Card */}
              <div className="min-w-[200px] p-4 bg-card rounded-lg shadow-lg flex flex-row items-center flex-shrink-0">
                <div className="flex items-center">
                  <TokenSymbol symbol="HOG" size={30} />
                  <div className="ml-[-8px]">
                    <TokenSymbol symbol="OS" size={30} />
                  </div>
                </div>
                {burnedValueUSD?.hogOsLp ? (
                  <span className="ml-2">${formatNumber(burnedValueUSD.hogOsLp)}</span>
                ) : (
                  <div className="ml-2">
                    <ShimmerLoader width="w-20" height="h-5" />
                  </div>
                )}
              </div>

              {/* GHOG/OS LP Card */}
              <div className="min-w-[200px] p-4 bg-card rounded-lg shadow-lg flex flex-row items-center flex-shrink-0">
                <div className="flex items-center">
                  <TokenSymbol symbol="GHOG" size={30} />
                  <div className="ml-[-8px]">
                    <TokenSymbol symbol="OS" size={30} />
                  </div>
                </div>
                {burnedValueUSD?.ghogOsLp ? (
                  <span className="ml-2">${formatNumber(burnedValueUSD.ghogOsLp)}</span>
                ) : (
                  <div className="ml-2">
                    <ShimmerLoader width="w-20" height="h-5" />
                  </div>
                )}
              </div>

              {/* HOG Card */}
              <div className="min-w-[200px] p-4 bg-card rounded-lg shadow-lg flex flex-row items-center flex-shrink-0">
                <TokenSymbol symbol="HOG" size={30} />
                <div className="ml-2">
                  {totalHogBurned && tokenPrices?.hog ? (
                    <span>${formatNumber(totalHogBurned * tokenPrices.hog)}</span>
                  ) : (
                    <ShimmerLoader width="w-20" height="h-5" />
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Carousel Animation Styles */}
          <style>
            {`
              @keyframes scroll {
                0% {
                  transform: translateX(0);
                }
                100% {
                  transform: translateX(-50%);
                }
              }
              .rfm-marquee-container {
                mask-image: linear-gradient(
                  to right,
                  transparent,
                  black 25%,
                  black 75%,
                  transparent
                );
              }
            `}
          </style>
        </div>

      <main className="theme-light bg-background text-foreground flex flex-col">
        <section className="transition-colors duration-700 bg-background text-foreground py-20 relative overflow-hidden theme-dark">
          <div className="absolute inset-0">
            <div className="relative container mx-auto">
              <div className="absolute w-full top-0 opacity-50 [mask-image:linear-gradient(to_right,transparent,black_50%,black_50%,transparent)]">
                <svg
                  className="-scale-y-100 w-full h-40"
                  width="100%"
                  height="200"
                  viewBox="0 0 100 200"
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <defs>
                    <linearGradient id="grad-light" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop stopColor="#102D3C"></stop>
                      <stop offset="0.161465" stopColor="#214E81"></stop>
                      <stop offset="0.363625" stopColor="#506179"></stop>
                      <stop offset="0.651499" stopColor="#ED5409"></stop>
                      <stop offset="1" stopColor="#FFCB67"></stop>
                    </linearGradient>
                    <linearGradient id="grad-dark" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop stopColor="#FFCB67"></stop>
                      <stop offset="0.161465" stopColor="#ED5409"></stop>
                      <stop offset="0.363625" stopColor="#506179"></stop>
                      <stop offset="0.651499" stopColor="#214E81"></stop>
                      <stop offset="1" stopColor="#102D3C"></stop>
                    </linearGradient>
                    <mask id="rectanglesMask">
                      <line x1="0" y1="0" x2="100" y2="0" stroke="white" strokeWidth="1"></line>
                      <line x1="0" y1="10" x2="100" y2="10" stroke="white" strokeWidth="1"></line>
                      <line x1="0" y1="20" x2="100" y2="20" stroke="white" strokeWidth="1.5"></line>
                      <line x1="0" y1="30" x2="100" y2="30" stroke="white" strokeWidth="2"></line>
                      <line x1="0" y1="40" x2="100" y2="40" stroke="white" strokeWidth="2.5"></line>
                      <line x1="0" y1="50" x2="100" y2="50" stroke="white" strokeWidth="3"></line>
                      <line x1="0" y1="60" x2="100" y2="60" stroke="white" strokeWidth="3.5"></line>
                      <line x1="0" y1="70" x2="100" y2="70" stroke="white" strokeWidth="4"></line>
                      <line x1="0" y1="80" x2="100" y2="80" stroke="white" strokeWidth="4.5"></line>
                      <line x1="0" y1="90" x2="100" y2="90" stroke="white" strokeWidth="5"></line>
                      <line x1="0" y1="100" x2="100" y2="100" stroke="white" strokeWidth="5.5"></line>
                      <line x1="0" y1="110" x2="100" y2="110" stroke="white" strokeWidth="6"></line>
                      <line x1="0" y1="120" x2="100" y2="120" stroke="white" strokeWidth="6.5"></line>
                      <line x1="0" y1="130" x2="100" y2="130" stroke="white" strokeWidth="7"></line>
                      <line x1="0" y1="140" x2="100" y2="140" stroke="white" strokeWidth="7.5"></line>
                      <line x1="0" y1="150" x2="100" y2="150" stroke="white" strokeWidth="8"></line>
                      <line x1="0" y1="160" x2="100" y2="160" stroke="white" strokeWidth="8.5"></line>
                      <line x1="0" y1="170" x2="100" y2="170" stroke="white" strokeWidth="9"></line>
                      <line x1="0" y1="180" x2="100" y2="180" stroke="white" strokeWidth="9.5"></line>
                      <line x1="0" y1="190" x2="100" y2="190" stroke="white" strokeWidth="10"></line>
                      <line x1="0" y1="200" x2="100" y2="200" stroke="white" strokeWidth="10.5"></line>
                    </mask>
                  </defs>
                  <rect
                    width="100%"
                    height="100%"
                    className="fill-[url(#grad-light)] theme-dark:fill-[url(#grad-dark)]"
                    mask="url(#rectanglesMask)"
                  ></rect>
                </svg>
              </div>
            </div>
          </div>
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div
              className="absolute inset-0 opacity-[0.15] transition-opacity duration-700"
              style={{
                backgroundImage: 'radial-gradient(circle at center, rgb(255 255 255 / 0.4) 1px, transparent 1px)',
                backgroundSize: '40px 40px',
              }}
            ></div>
            <div
              className="absolute left-[15%] top-[50%] w-[40%] opacity-30 transition-[filter,transform,background] duration-700"
              style={{
                aspectRatio: '2/1',
                background: 'radial-gradient(#FF8A3D 0%, transparent 90%)',
                filter: 'blur(120px)',
                transform: 'rotate(45deg)',
              }}
            ></div>
            <div
              className="absolute right-[15%] top-[30%] w-[40%] opacity-30 transition-[filter,transform,background] duration-700"
              style={{
                aspectRatio: '2/1',
                background: 'radial-gradient(#3D76FF 0%, transparent 90%)',
                filter: 'blur(120px)',
                transform: 'rotate(-45deg)',
              }}
            ></div>
          </div>
          <div className="flex flex-col items-center gap-y-8 relative" style={{minHeight: "50vh"}}>
            <div className="container mx-auto flex flex-col gap-y-4 items-center">
              <h2 className="font-urbanist text-m-h2 md:text-t-h2 lg:text-d-h2 font-medium text-center max-w-[14ch] leading-none md:leading-tight">
                Scriptures
              </h2>
            </div>
            
            {/* Add the TWAPChart component here */}
            <TWAPChart data={chartData} />

            <div className='space-y-4 w-full max-w-7xl mx-auto px-4 md:px-8'>
              <div className='rounded-md border overflow-x-auto'>
                <div className='relative w-full overflow-auto'>
                  <table className="caption-bottom text-sm w-full table-auto">
                    <thead className='[&_tr]:border-b bg-component'>
                      <tr className='border-b leading-none hover:bg-muted/50 data-[state=selected]:bg-muted'>
                        <th className='h-10 px-2 text-left align-middle font-semibold text-component-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]'>Epoch</th>
                        <th className='h-10 px-2 text-left align-middle font-semibold text-component-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]'>Elysium emission per sec</th>
                        <th className='h-10 px-2 text-left align-middle font-semibold text-component-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]'>Sanctum emission rate</th>
                        <th className='h-10 px-2 text-left align-middle font-semibold text-component-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]'>Sanctum funding</th>
                        <th className='h-10 px-2 text-left align-middle font-semibold text-component-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]'>DAO funding</th>
                        <th className='h-10 px-2 text-left align-middle font-semibold text-component-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]'>Burn</th>
                        <th className='h-10 px-2 text-left align-middle font-semibold text-component-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]'>Total</th>
                        <th className='h-10 px-2 text-left align-middle font-semibold text-component-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]'>Bond Parameters</th>
                        <th className='h-10 px-2 text-left align-middle font-semibold text-component-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]'>
                          <div className="flex items-center gap-2">
                            <TokenSymbol symbol="god" size={18} />
                            <span>GOD_AI Analysis</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className='[&_tr:last-child]:border-0'>
                      {paginatedRows.map((row, index) => {
                        const epochInfo = epochData[parseInt(row.epoch)];
                        const twap = parseFloat(row.twap);
                        
                        // Determine background color based on TWAP
                        let bgColor = '';
                        if (twap > 1.01) {
                          bgColor = PRICE_COLORS.EXPANSION;
                        } else if (twap >= 1.00 && twap <= 1.01) {
                          bgColor = PRICE_COLORS.ZEN;
    } else {
                          bgColor = PRICE_COLORS.CONTRACTION;
                        }
                        
                        return (
                          <tr
                            className='border-b leading-none hover:bg-muted/50 data-[state=selected]:bg-muted'
                            key={row.epoch}
                            style={{ backgroundColor: bgColor }}
                          >
                            <td className='p-2 align-middle'>
                              {row.epoch}
                            </td>
                            <td className='p-2 align-middle'>
                              <div className="flex flex-col gap-1">
                                <div className="flex items-center gap-1">
                                  HOG/OS: <TokenSymbol symbol="GHOG" size={20} /> 
                                  {row.pool0EmissionRate ? row.pool0EmissionRate : '0'}
                                </div>
                                <div className="flex items-center gap-1">
                                  GHOG/OS: <TokenSymbol symbol="GHOG" size={20} /> 
                                  {row.pool1EmissionRate ? row.pool1EmissionRate : '0'}
                                </div>
                              </div>
                            </td>
                            <td className='p-2 align-middle'>
                              {row.expansionRate ? (
                                `${row.expansionRate}%`
                              ) : epochInfo ? (
                                `${epochInfo.expansion_rate}%`
                              ) : (
                                <ShimmerLoader width="w-16" height="h-5" />
                              )}
                            </td>
                            <td className='p-2 align-middle'>
                              <div className="flex items-center gap-1">
                                <TokenSymbol symbol="HOG" size={20} /> 
                                {row.totalFundAmount ? (row.totalFundAmount - (row.daoFundAmount + row.devFundAmount + row.teamFundAmount)).toFixed(2) : '0'}
                              </div>
                            </td>
                            <td className='p-2 align-middle'>
                              <div className="flex items-center gap-1">
                                <TokenSymbol symbol="HOG" size={20} /> 
                                {row.daoFundAmount?.toFixed(2) || '0'}
                              </div>
                            </td>
                            <td className='p-2 align-middle'>
                              <div className="flex items-center gap-1">
                                <TokenSymbol symbol="HOG" size={20} /> 
                                {((row.devFundAmount || 0) + (row.teamFundAmount || 0)).toFixed(2)}
                              </div>
                            </td>
                            <td className='p-2 align-middle'>
                              <div className="flex items-center gap-1">
                                <TokenSymbol symbol="HOG" size={20} /> 
                                {row.totalFundAmount?.toFixed(2) || '0'}
                              </div>
                            </td>
                            <td className='p-2 align-middle'>
                              {row.isContraction ? (
                                `Discount: ${bondStat?.hogprice ? ((bondStat.hogprice - 1) * 100).toFixed(2) : '-'}%`
                              ) : (
                                '-'
                              )}
                            </td>
                            <td className='p-2 align-middle'>
                              {epochInfo ? (
                                <div className="flex flex-col gap-2">
                                  {row.epoch === '29' && (
                                    <a 
                                      href="https://x.com/GodSonic_AI/status/1899965193980932422"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-blue-500 hover:text-blue-700 underline"
                                    >
                                      View Elysium Analysis
                                    </a>
                                  )}
                                  {row.epoch === '57' && (
                                    <a 
                                      href="https://x.com/GodSonic_AI/status/1902503294401999234"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-blue-500 hover:text-blue-700 underline"
                                    >
                                      View Elysium Analysis
                                    </a>
                                  )}
                                  <a 
                                    href={epochInfo.tweet_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500 hover:text-blue-700 underline"
                                  >
                                    View Sanctum Analysis
                                  </a>
                                </div>
                              ) : (
                                <ShimmerLoader width="w-32" height="h-5" />
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  
                  {/* Add Pagination Controls */}
                  <div className="flex items-center justify-between p-4 border-t border-[#38332Eaa] bg-black/50">
                    <div className="text-sm text-[#dc9d3f]">
                      Showing {rows ? page * rowsPerPage + 1 : 0} to {rows ? Math.min((page + 1) * rowsPerPage, rows.length) : 0} of {rows?.length || 0} entries
                    </div>
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="px-4 py-2 text-[#dc9d3f] border border-[#38332Eaa] rounded-md 
                                 hover:bg-[#38332Eaa] disabled:opacity-50 disabled:cursor-not-allowed
                                 transition-colors duration-200"
                      >
                        Previous
                      </button>
                      <button
                        onClick={() => handleChangePage(null, page + 1)}
                        disabled={!rows || (page + 1) * rowsPerPage >= rows.length}
                        className="px-4 py-2 text-[#dc9d3f] border border-[#38332Eaa] rounded-md 
                                 hover:bg-[#38332Eaa] disabled:opacity-50 disabled:cursor-not-allowed
                                 transition-colors duration-200"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </Page>
  );
};

export default Regulations;
